export default __webpack_public_path__ + "static/media/card-paypal.a14783de.svg";